import { SESSION_STORAGE_KEYS } from '../appConstants';
import { APP_EVENT_NAMES } from '../signalR/constants';
import Events from '@EventEmitter';

// Get the stored city routes map from session storage
const getStoredMap = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_STORAGE_KEYS.PENDING_DR_CITY_ROUTES);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

// Write the city routes map to session storage
const setStoredMap = (map) => {
  sessionStorage.setItem(SESSION_STORAGE_KEYS.PENDING_DR_CITY_ROUTES, JSON.stringify(map));
};

// Store city routes for a scenario (used when navigating from "Create Routes")
export const setCityRoutesForScenario = (scenarioId, cityRoutes) => {
  if (!scenarioId || !cityRoutes?.length) return;
  const map = getStoredMap();
  map[scenarioId] = cityRoutes;
  setStoredMap(map);
};

// Get city routes for a scenario
export const getCityRoutesForScenario = (scenarioId) => {
  if (!scenarioId) return [];
  const map = getStoredMap();
  return map[scenarioId] || [];
};

// Remove city routes for a scenario (used when Dynamic Routing completes successfully)
export const removeCityRoutesForScenario = (scenarioId) => {
  if (!scenarioId) return;
  const map = getStoredMap();
  delete map[scenarioId];
  setStoredMap(map);
  Events.emit(APP_EVENT_NAMES.IBPLANNING.ClearETLCityRoutes, scenarioId);
};

// Clear all city routes from session (used on logout)
export const clearAllCityRoutes = () => {
  sessionStorage.removeItem(SESSION_STORAGE_KEYS.PENDING_DR_CITY_ROUTES);
};
